import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ImageUploader from "../../misc/ImageUploader";
import ImageZoom from "../../misc/ImageWithZoom";
import Save from "../../../../../icons/save";
import axios from "axios";

const CarouselModal = () => {

  const [pictureOneCarouselModal, setPictureOneCarouselModal] =
    useState<File>();
  const [pictureOneCarouselModalPreview, setPictureOneCarouselModalPreview] =
    useState<string>("");
  const [pictureOneCarouselModalURL, setPictureOneCarouselModalURL] =
    useState<string>("");

  const handleCarouselModal = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    Swal.fire({
      title: "Uploading...",
      text: "Please wait while we upload the images.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      if (pictureOneCarouselModal) {
        const fileKey = `publicidad/${pictureOneCarouselModal.name}`;
        const { data: uploadData } = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/s3/upload-url`,
          { key: fileKey },
          { headers: { "auth-token": sessionStorage.getItem("token") } }
        );
        await axios.put(uploadData.url, pictureOneCarouselModal, { headers: { "Content-Type": pictureOneCarouselModal.type } });
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/publicidad?type=modalPictureOne`,
          {
            image: fileKey,
            external_url: pictureOneCarouselModalURL,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "auth-token": `${sessionStorage.getItem("token")}`,
            },
          }
        );
      }
      Swal.fire({
        icon: "success",
        title: "Images uploaded successfully",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "An error occurred during the upload.",
      });
      console.error("Error uploading file:", error);
    }
  };

  const getCarouselModal = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/publicidad/modal`
      );

      let tempImageOne = response.data.filter(
        (image: any) => image.placement === "modalPictureOne"
      );
 

      if (tempImageOne[0]?.link) {
        try {
          const { data: s3Data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/s3/signed-url?key=${encodeURIComponent(tempImageOne[0].link)}`,
            { headers: { "auth-token": sessionStorage.getItem("token") } }
          );
          setPictureOneCarouselModalPreview(s3Data.url);
          setPictureOneCarouselModalURL(tempImageOne[0].external_url);
        } catch (err) { console.error(err); }
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getCarouselModal();
  }, []);

  return (
    <div className="p-2 border border-slate-200 rounded m-2">
      <p>Modal</p>
  
      <form action="" className="gap-2 my-4" onSubmit={handleCarouselModal}>
        <div className="flex">
          <h1>Seccion Modal</h1>
          <button>
            <Save size={26} />
          </button>
        </div>
        <div className="flex gap-2">
          <div className="flex flex-col gap-2">
            <p>Foto #1</p>
            <input
              value={pictureOneCarouselModalURL}
              type="text"
              className="main-input"
            />
            <ImageUploader
              setSelectedFile={setPictureOneCarouselModal}
              inputId="CarouselModalPictureOne"
            />
            <p>
              <strong>Previo</strong>
            </p>
            <ImageZoom imageUrl={pictureOneCarouselModalPreview} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CarouselModal;
